var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".arrow-right-1{fill:none;stroke:#fff;stroke-miterlimit:10;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("line",{"className":"arrow-right-1","x1":"47.25","y1":"17.12","y2":"17.12","key":0}),React.createElement("polyline",{"className":"arrow-right-1","points":"27.23 0.38 47.24 17.12 27.23 35.59","key":1})]))]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 48 35.96"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
